import { render, staticRenderFns } from "./sellers.vue?vue&type=template&id=cdfd3b84&"
import script from "./sellers.vue?vue&type=script&lang=js&"
export * from "./sellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports